"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlatAreasSuggest = getFlatAreasSuggest;
exports.setFlatAreaResponse = void 0;
var _validateAddressWeb = require("../../shared/repositories/price-estimator/v1/validate-address-web");
var _getFlatAreasDesktop = require("../../shared/repositories/price-estimator/v1/get-flat-areas-desktop");
var _filters = require("../filters");
var _types = require("./types");
var _actionGenerator = require("../../utils/actionGenerator");
/* eslint-disable */

const {
  FLAT_AREA_SUCCESS_RESPONSE: RESPONSE
} = _types.EActionTypes;
const setFlatAreaResponse = exports.setFlatAreaResponse = (0, _actionGenerator.actionGenerator)(RESPONSE);
function getFlatAreasSuggest(selectedAddress) {
  return (dispatch, getState, context) => {
    const {
      httpApi
    } = context;
    return (0, _validateAddressWeb.fetchValidateAddressWeb)({
      httpApi,
      parameters: {
        address: selectedAddress
      }
    }).then(response => {
      if (response.statusCode === 200) {
        dispatch((0, _filters.setHouseId)({
          houseId: response.response.houseId
        }));
        return (0, _getFlatAreasDesktop.fetchGetFlatAreasDesktop)({
          httpApi,
          parameters: {
            address: selectedAddress
          }
        });
      }
      return Promise.reject(response);
    }).then(response => {
      if (response.statusCode === 200) {
        const {
          flatAreas
        } = response.response;
        dispatch(setFlatAreaResponse({
          flatAreas
        }));
      }
    }).catch(response => {
      if (response.statusCode === 400) {
        const errors = response.response.errors || [];
        const error = errors[0] || {};
        const {
          key,
          message
        } = error;
        if (key && message) {
          dispatch((0, _filters.setError)({
            currentErrorField: key,
            errorText: message
          }));
        }
      } else {
        context.logger.error(response);
      }
    });
  };
}